import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Children, isValidElement, useMemo, } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
export const useWrapTextChildren = (children) => {
    return useMemo(() => Children.toArray(children).map((child, idx) => {
        const isFormattedMessage = isValidElement(child) && child.type === FormattedMessage;
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        return typeof child === 'string' || isFormattedMessage ? (_jsx(TextWrap, { children: child }, `${child}-${idx}`)) : (child);
    }), [children]);
};
export const WrapTextChildren = ({ children }) => (_jsx(_Fragment, { children: useWrapTextChildren(children) }));
export const withTextWrap = (WrappedComponent) => 
// eslint-disable-next-line react/display-name
(props) => (_jsx(TextWrap, { children: _jsx(WrappedComponent, { ...props }) }));
export const TextWrap = styled.span ``;
//# sourceMappingURL=textWrap.js.map